import { createContext, FC, ReactNode, useMemo, useState } from "react";
import { AppVariant, AppVersion } from "../types";

export type AppVariantContextType = {
  variant: AppVariant;
  isDemo: boolean;
  version: AppVersion;
  setVersion: (version: AppVersion) => void;
};

export const AppVariantContext = createContext<AppVariantContextType | null>(
  null
);

type AppVariantProviderProps =
  | {
      children: ReactNode;
      isDemo?: boolean;
      variant: AppVariant;
      defaultVersion?: AppVersion;
    }
  | {
      children: ReactNode;
      isDemo?: boolean;
      auto: boolean;
      defaultVersion?: AppVersion;
    };

const isMobileDevice = () => {
  const userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    (window as unknown as { opera: string }).opera;
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(userAgent);
};

export const AppVariantProvider: FC<AppVariantProviderProps> = ({
  children,
  ...props
}) => {
  const [version, setVersion] = useState<AppVersion>(
    props.defaultVersion ?? "general"
  );

  const value: AppVariantContextType = useMemo(() => {
    let variant: AppVariant = "web";
    if ("variant" in props) {
      variant = props.variant;
    }
    if (isMobileDevice()) {
      variant = "mobile";
    }
    return {
      variant,
      isDemo: props.isDemo ?? false,
      version,
      setVersion,
    };
  }, [props, version]);

  return (
    <AppVariantContext.Provider value={value}>
      {children}
    </AppVariantContext.Provider>
  );
};
